import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const navItems = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/romance' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 w-full">
      <nav className="bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-lg text-background-50"></i>
              </span>
              <span className="text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>韩漫屋</span>
            </Link>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href))
                      ? 'text-primary-500'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Search + Mobile Toggle */}
            <div className="flex items-center gap-3">
              <div className="hidden sm:flex items-center bg-background-100 rounded-full px-4 py-2 gap-2">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-900 placeholder-foreground-400 w-40"
                />
              </div>
              <button
                className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="菜单"
              >
                <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
            <div className="flex flex-col gap-3">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={() => setMobileOpen(false)}
                  className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors ${
                    location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href))
                      ? 'bg-primary-100 text-primary-600'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <div className="sm:hidden flex items-center bg-background-100 rounded-full px-4 py-2 gap-2 mt-2">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-900 placeholder-foreground-400 w-full"
                />
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}